import { Link } from 'react-router-dom';
import { Icon } from '../ui/Icon';
import { Accordéon } from '../ui/kit';
import { clsBouton, Fil } from './partages';
import { BOUTIQUES, QUESTIONS, REGLAGES } from '../data/mock-data';
import { eur, eurSansCentimes } from '../data/repository';

/** LIVRAISON & RETRAIT — les règles du jeu, dites une fois, clairement. */
export function Livraison() {
  return (
    <main id="contenu" className="mx-auto max-w-[1080px] px-5 py-8 sm:px-6">
      <Fil fils={[{ libelle: 'Livraison & retrait' }]} />

      <div className="max-w-2xl">
        <p className="eyebrow">Comment ça arrive</p>
        <h1 className="mt-2 text-balance text-[clamp(2rem,4.6vw,3.2rem)]">Deux façons,<br />jamais de mauvaise surprise.</h1>
        <p className="mt-4 text-[1.0625rem] leading-relaxed text-ink-soft">
          Le retrait est gratuit et prêt sous {REGLAGES.creneaux.delaiDecoupeH} heures. La livraison est
          réfrigérée, offerte dès {eurSansCentimes(REGLAGES.livraison.seuilGratuite)}, et vous avez{' '}
          {REGLAGES.livraison.reclamationFroidH} heures pour signaler un problème de froid.
        </p>
      </div>

      <div className="mt-10 grid gap-5 lg:grid-cols-2">
        {/* Retrait */}
        <article className="rounded-[24px] bg-surface p-6 shadow-card">
          <div className="flex items-center gap-3">
            <span className="grid h-11 w-11 place-items-center rounded-full bg-linen text-wine"><Icon name="store" size={20} /></span>
            <div>
              <h2 className="font-display text-2xl">Retrait en boutique</h2>
              <p className="text-sm text-muted">Gratuit · dès {REGLAGES.creneaux.delaiDecoupeH} h</p>
            </div>
          </div>
          <ul className="mt-5 space-y-3 text-[0.9375rem] text-ink-soft">
            {[
              `Vous choisissez un créneau de ${REGLAGES.creneaux.granulariteMin} minutes, sur ${REGLAGES.creneaux.joursOuverts} jours.`,
              'La pièce est découpée le matin même et mise au frais à votre nom.',
              'Vous réglez le solde au comptoir, après pesée.',
              'Les arrhes déjà versées se déduisent automatiquement.',
            ].map(t => <li key={t} className="flex gap-2.5"><Icon name="check" size={16} className="mt-1 shrink-0 text-success" />{t}</li>)}
          </ul>
          <div className="mt-5 rounded-xl bg-linen p-4 text-sm">
            <p className="font-semibold">Trois comptoirs</p>
            <p className="mt-1 text-muted">{BOUTIQUES.map(b => b.nom).join(' · ')}</p>
          </div>
          <Link to="/nos-boutiques" className={clsBouton('outline', 'mt-5 btn--block')}>Voir les horaires</Link>
        </article>

        {/* Livraison */}
        <article className="rounded-[24px] bg-ink p-6 text-lin-50 shadow-card">
          <div className="flex items-center gap-3">
            <span className="grid h-11 w-11 place-items-center rounded-full bg-lin-50/10 text-brass-soft"><Icon name="truck" size={20} /></span>
            <div>
              <h2 className="font-display text-2xl text-lin-50">Livraison réfrigérée</h2>
              <p className="text-sm text-lin-50/60">{REGLAGES.livraison.delaiMinH}–{REGLAGES.livraison.delaiMaxH} h ouvrées</p>
            </div>
          </div>
          <ul className="mt-5 space-y-3 text-[0.9375rem] text-lin-50/75">
            {[
              `Colis isotherme maintenu ${REGLAGES.livraison.temperature}, expédié en ${REGLAGES.livraison.transporteur}.`,
              `Offerte dès ${eur(REGLAGES.livraison.seuilGratuite)} d’achat, sinon ${eur(REGLAGES.livraison.fraisChronofresh)}.`,
              `Commande avant ${REGLAGES.livraison.coupure} pour un départ le jour ouvré suivant.`,
              'Réglée intégralement en ligne — aucune arrhes à ajouter.',
            ].map(t => <li key={t} className="flex gap-2.5"><Icon name="check" size={16} className="mt-1 shrink-0 text-brass-soft" />{t}</li>)}
          </ul>
          <div className="mt-5 rounded-xl bg-lin-50/[0.07] p-4 text-sm">
            <p className="font-semibold text-brass-soft">{REGLAGES.livraison.transporteur}, partout en France</p>
            <p className="mt-1 text-lin-50/65">
              Expédié {REGLAGES.livraison.joursExpedition[0].toLowerCase()} → {REGLAGES.livraison.joursExpedition.at(-1)?.toLowerCase()},
              livré en {REGLAGES.livraison.delaiMinH}–{REGLAGES.livraison.delaiMaxH} h ouvrées, colis isotherme.
            </p>
          </div>
          <div className="mt-2 rounded-xl bg-lin-50/[0.07] p-4 text-sm">
            <p className="font-semibold text-brass-soft">Coursier réfrigéré local</p>
            <p className="mt-1 text-lin-50/65">
              {REGLAGES.livraison.zonesCoursier.join(' · ')} — livré le jour même selon les créneaux
              proposés au panier. {eur(REGLAGES.livraison.fraisCoursier)}, offert dès{' '}
              {eur(REGLAGES.livraison.seuilCoursierGratuit)}.
            </p>
          </div>
          <Link to="/boutique" className={clsBouton('primary', 'mt-5 btn--block')}>Commander</Link>
        </article>
      </div>

      {/* Chaîne du froid */}
      <section className="mt-8 rounded-[22px] bg-brass-wash p-5 sm:p-6">
        <div className="flex flex-wrap items-center gap-4">
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-surface text-brass-ink"><Icon name="snow" size={20} /></span>
          <div className="min-w-0 flex-1">
            <h2 className="font-display text-xl text-brass-ink">Si le froid a été rompu</h2>
            <p className="mt-1 text-sm leading-relaxed text-brass-ink/85">
              Vous avez {REGLAGES.livraison.reclamationFroidH} heures après réception pour nous le signaler —
              photo à l’appui, par téléphone ou par e-mail. Nous remplaçons la pièce ou nous remboursons,
              sans discussion.
            </p>
          </div>
        </div>
      </section>

      {/* Questions */}
      <section className="mt-12">
        <h2 className="text-2xl">Les questions qu’on nous pose</h2>
        <div className="mt-4">
          {[...QUESTIONS.slice(0, 4), {
            question: 'Et si je ne suis pas là à la livraison ?',
            reponse: `Le colis reste au frais ${REGLAGES.livraison.delaiMaxH} h grâce aux plaques eutectiques. Nous repassons, ou vous le retirez en boutique sous ${REGLAGES.creneaux.delaiDecoupeH} h. Dans les deux cas, un appel suffit : le transporteur ne laisse jamais un colis dehors.`,
          }].map((q, i) => (
            <Accordéon key={q.question} titre={q.question} ouvertParDefaut={i === 0}>{q.reponse}</Accordéon>
          ))}
        </div>
      </section>
    </main>
  );
}
